import { useRouter } from 'next/router';
import React, { useEffect } from 'react'
import Ingredientstyle from './Ingredients.style';
import { LinkAnchor } from '../CommonMethods';

const SupplementsList = ({ data }) => <div className='ingre-list'><ul>{data?.map((item) => <li key={item.toString()}>{item}</li>)}</ul></div>;

const IngredientList = () => {
    const array = ["ApoB", "ATP5C1", "CYP11B2", "EPHX1", "FTO", "FUT2",]
    const array1 = ["GSTP-1", "IL-6", "COMT", "CRP", "MTHFR", "MTRR",]
    const array2 = ["PON-1", "SOD2", "TNF-a", "NQO1", "VDR"]
    const router = useRouter();

    return (
        <Ingredientstyle>
            <div className='ingredients'>
                <h2> Genes We Test To Analyze <br /> Your Unique Nutritional Needs:</h2>
                <div className='nutritional-needs d-flex'>
                    <SupplementsList data={array} />
                    <p className='border'></p>
                    <SupplementsList data={array1} />
                    <p className='border'></p>
                    <SupplementsList data={array2} />
                </div>
                {router?.asPath === "/us/retailers/" ?
                    <div className='ingredients-paragraph'>
                        <p>Ingredients utilized to support your customers genetic expressions are unique to them.</p>
                    </div>
                    :
                    <div className='ingredients-paragraph'>
                        <p>Request ingredients utilized to support your patients and clients genetic expressions that are unique to them.</p>
                    </div>
                }
                <div className='ingredient-list-button'>
                    <button className='btn-primary-incredient'>
                        <LinkAnchor href="mailto:support@snipnutrition.com?subject=Ingredients list request"
                            style={{ color: "#fff" }}>REQUEST INGREDIENT LIST</LinkAnchor>
                    </button>
                </div>
            </div>
        </Ingredientstyle >
    )
}

export default IngredientList